import React, { ElementType, ReactElement, ReactNode } from 'react'
import { Flex } from 'theme-ui'
import UseCasesIcon from 'images/organization/features/malware/use-cases-icon.svg'
import { Svg } from 'ui'
import FeatureUseCasesItem from './FeatureUseCasesItem'
import UseCasesBlur from 'images/organization/features/malware/usecase-glow.svg'
import { TextWithBreakpointVariant } from 'ui/TextWithBreakpointVariant'

export interface UseCaseItem {
  image: ElementType
  title: string
  text: string | ReactNode
}

export function FeatureUseCases({
  title,
  data,
}: {
  title: string
  data: UseCaseItem[]
}): ReactElement {
  return (
    <Flex
      sx={{
        width: '100%',
        px: ['1.6rem', '1.6rem', 0],
        mt: ['16rem', '20rem'],
        flexDirection: 'column',
        textAlign: 'center',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          alignItems: 'center',
          height: 'fit-content',
          mb: ['4rem', '4.8rem'],
        }}
      >
        <Flex
          sx={{
            position: 'relative',
            width: '8rem',
            height: '8rem',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Svg svg={UseCasesIcon} descriptiveText="Use cases section icon" />
        </Flex>
        <TextWithBreakpointVariant
          variant={['size28Weight600', 'size40Weight600']}
          as="h2"
          sx={{
            maxWidth: '54rem',
            color: 'aliceBlue',
            mt: '1.6rem',
          }}
          tabIndex={0}
        >
          {title}
        </TextWithBreakpointVariant>
        <Svg
          svg={UseCasesBlur}
          sx={{ position: 'absolute', top: '-10rem', width: ['auto', 'auto'], zIndex: 'zIndex0' }}
          descriptiveText="Decorative glow effect for use cases section"
        />
      </Flex>
      <Flex
        sx={{
          flexWrap: 'wrap',
          justifyContent: 'center',
          width: '100%',
          maxWidth: '110rem',
          gap: ['4rem', '3.2rem'],
          zIndex: 'zIndex1',
        }}
      >
        {data?.map((item, key) => (
          <FeatureUseCasesItem
            key={key}
            title={item.title}
            subText={item.text}
            image={item.image}
          />
        ))}
      </Flex>
    </Flex>
  )
}

export default FeatureUseCases
